import { useCallback, useEffect, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import ModulesDashboard from '../../components/Modules/ModulesDashboard';
import ModulesService from '../../services/ModulesService';

const Unit3Navigation = () => {
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const [modulesConfig, setModulesConfig] = useState([]);

  const IMAGES_ENDPOINT = login.cloudFront + 'images';

  const WorldMap = `${IMAGES_ENDPOINT}/Images/Worlds/WorldMap_Large_Unit3_5of5.png${login.cookie}`;

  const getModulesConfiguration = useCallback(
    (modules) => {
      const mappedModules = modules
        .filter((module) => module.unit === 3)
        .map((module) => {
          let config = {};

          if (module.name === 'Feelings') {
            config = ModulesService.getModuleConfig({
              order: 0,
              currentModule: module,
              previousModule: null,
              totalDays: 9,
              bgImage: '/Module11Images/Unit3_Mod1_Background-1.png',
              destiny: '/feelings/navigation',
              title: 'Feelings',
              character: 'Crab',
              welcomeVideo: '4648cee460dd5c6149b2ebbe506c/480.m3u8',
              login,
            });
            dispatch({ type: 'SET_MODULE11_INITIALSTATE', payload: module });
          }

          if (module.name === 'UnderstandFeelings') {
            config = ModulesService.getModuleConfig({
              order: 1,
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'Feelings'
              ),
              totalDays: 9,
              bgImage: '/Module12Images/Unit3_Mod2BG.png',
              destiny: '/understandfeelings/navigation',
              title: 'Understand Feelings',
              character: 'Dog',
              welcomeVideo: 'e5b8d8ac9d23b16032fea8d20eb3/480.m3u8',
              login,
            });
            dispatch({
              type: 'SET_MODULE12_INITIALSTATE',
              payload: module,
            });
          }

          if (module.name === 'ChangeFeelings') {
            config = ModulesService.getModuleConfig({
              order: 2,
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'UnderstandFeelings'
              ),
              totalDays: 9,
              bgImage:
                '/Module13Images/Unit3Mod3_JourneyMap.png',
              destiny: '/changefeelings/navigation',
              title: 'Change Feelings',
              character: 'Lizard',
              welcomeVideo: 'e7dab042a011d679bf7f800a6a8b/480.m3u8',
              login,
            });

            dispatch({
              type: 'SET_MODULE13_INITIALSTATE',
              payload: module,
            });
          }

          if (module.name === 'Solutions') {
            config = ModulesService.getModuleConfig({
              order: 3,
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'ChangeFeelings'
              ),
              totalDays: 9,
              bgImage:
                '/Module14Images/JourneyMap14Version2-01.png',
              destiny: '/solutions/navigation',
              title: 'Solutions',
              character: 'Monkey',
              welcomeVideo: '685fbf34a6cf0399cff4a6533d83/480.m3u8',
              login,
            });

            dispatch({
              type: 'SET_MODULE14_INITIALSTATE',
              payload: module,
            });
          }

          if (module.name === 'ActiveListening') {
            config = ModulesService.getModuleConfig({
              order: 4,
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'Solutions'
              ),
              totalDays: 9,
              bgImage:
                '/Module15Images/JourneyMap15Version3-01.png',
              destiny: '/activelistening/navigation',
              title: 'Active Listening',
              character: 'Bird',
              welcomeVideo: '6251b93568f8edab15ebfb99a2aa/480.m3u8',
              login,
            });

            dispatch({
              type: 'SET_MODULE15_INITIALSTATE',
              payload: module,
            });
          }

          return {
            ...module,
            ...config,
          };
        });
      setModulesConfig(mappedModules);
    },
    [dispatch, login]
  );

  const getStudentModules = useCallback(async () => {
    const data = await ModulesService.getStudentModules(login.endPoint);
    getModulesConfiguration(data.modules);
  }, [getModulesConfiguration]);

  useEffect(() => {
    getStudentModules();
  }, [getStudentModules]);

  return (
    <ModulesDashboard
      modules={modulesConfig.sort(function (a, b) {
        return a.order - b.order;
      })}
      pageTitle='Understanding Emotions'
      worldMapImage={WorldMap}
      grade={login.grade}
      unit={3}
    />
  );
};
export default Unit3Navigation;
